import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LayoutComponent } from "./app-common/layout/layout.component";

const routes: Routes = [
  { path: "ihs-interest-form", loadChildren: () => import("./ihs/interest-form/interest-form.module").then((m) => m.InterestFormModule) },
  { path: "", loadChildren: () => import("src/app/app-common/app-common.module").then((m) => m.AppCommonModule) },
  {
    path: "",
    component: LayoutComponent,
    children: [
      { path: "dashboard", loadChildren: () => import("./ihs/dashboard/dashboard.module").then((m) => m.DashboardModule) },
      { path: "usermanagement", loadChildren: () => import("./ihs/users/users.module").then((m) => m.UsersModule) },
      { path: "leadmanagement", loadChildren: () => import("./ihs/leads/leads.module").then((m) => m.LeadsModule) },
      { path: "dashboard/leads", loadChildren: () => import("./ihs/leads/leads.module").then((m) => m.LeadsModule) },
      { path: "rolemanagement", loadChildren: () => import("./ihs/roles/roles.module").then((m) => m.RolesModule) },
      { path: 'reports', loadChildren: () => import("./ihs/reports/reports.module").then((m) => m.ReportsModule) }
    ]
  },
  { path: '**', loadChildren: () => import('src/app/app-common/app-common.module').then(m => m.AppCommonModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
